import { ProductsActionTypes } from "./types";
import { IProductState } from "../../models/product.interface";
import { Dispatch } from "redux";
import { productsService } from "../../services/products.service";

export interface ProductsAction {
  type: ProductsActionTypes;
  payload: IProductState;
}

export const productsActions = {
  getProducts: (agentCode: string, from: Date) => {
    return async (dispatch: Dispatch) => {
      dispatch<ProductsAction>({
        type: ProductsActionTypes.GET_PRODUCTS,
        payload: {products:[], error: null}
      });

      await productsService.getProducts(agentCode, from).then(response => {
        dispatch<ProductsAction>({
          type: ProductsActionTypes.GET_PRODUCTS_COMPLETED,
          payload: {products: response.data, error: null}
        });
      }).catch(reason => {
        dispatch<ProductsAction>({
          type: ProductsActionTypes.GET_PRODUCTS_FAILED,
          payload: { products: [], error: new Date() }
        });
      });
    };
  }
};
